module.exports = __webpack_public_path__ + "static/media/TonoDaruma_06B.094a93e1.gif";